import React from 'react';
import InsertPageBreakTwoToneIcon from '@mui/icons-material/InsertPageBreakTwoTone';
import {Box, Button} from '@mui/material';

function PaginaNoEncontrada() {
	return (
		<Box
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			textAlign="center"
			marginTop={8}
			marginRight={8}
			marginBottom={8}
			marginLeft={8}
			data-testid="pagina-no-encontrada"
		>
			<h1>No Encontrado</h1>
			<p>La página que buscas no existe</p>
			<InsertPageBreakTwoToneIcon />
			<Button
				type="submit"
				variant="contained"
				sx={{
					py: '0.8rem',
					mt: 2,
					width: '80%',
					maxWidth: '300px',
					marginInline: 'auto',
				}}
				data-testid="boton-regresar"
				onClick={() => {
					window.history.back();
				}}
			>
          Regresar
			</Button>
		</Box>
	);
}

export default PaginaNoEncontrada;
